module.exports = __webpack_public_path__ + "img/svg/back.711f379807377f6a5ac1ff272a70d6b0.svg";